var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('navigation-landing'),_c('v-main',[_vm._t("default"),_c('footer-menu')],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }